import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-hanta',
  templateUrl: './hanta.component.html',
  styleUrls: ['./hanta.component.scss']
})
export class HantaComponent implements OnInit {

  exposition: CardContent = {
    title: 'Hanta-Prediction',
    subtitle: 'An early warning system for hantavirus outbreaks',
    image_source: 'assets/images/Hanta-Prediction.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients / Partners</h4>LGA Stuttgart, Epimos, Nationale Forschungsplattform für&nbsp;Zoonosen',
      '<h4>Methods</h4>Data Visualisation',
      '<h4>Technology / Skills</h4>Javascript, D3',
      '<h4>Term</h4>2014-17',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
